import { ReactElement } from "react";
import { CollectionType } from "../../../apis/bacchus/collections";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import SettingsIcon from "@mui/icons-material/Settings";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";

export interface GroupedOption {
  header: string;
  icon: ReactElement;
  options: { value: CollectionType; label: string }[];
}

export const GROUPED_OPTIONS: GroupedOption[] = [
  {
    header: "Geography",
    icon: <LocationOnIcon fontSize="small" />,
    options: [
      { value: "country", label: "Country" },
      { value: "state", label: "State" },
    ],
  },
  {
    header: "Industry",
    icon: <BusinessIcon fontSize="small" />,
    options: [
      { value: "industry", label: "Industry" },
      { value: "naics", label: "NAICS" },
      { value: "sic", label: "SIC" },
    ],
  },
  {
    header: "Tech Installs",
    icon: <SettingsIcon fontSize="small" />,
    options: [
      { value: "product", label: "Product" },
      { value: "product_category", label: "Product Category" },
      { value: "product_attribute", label: "Product Attribute" },
      { value: "vendor", label: "Vendor" },
    ],
  },
  {
    header: "Intent",
    icon: <AutoGraphIcon fontSize="small" />,
    options: [{ value: "intent", label: "Intent Topics" }],
  },
];
